import { apiSlice } from "./apiSlice";
import { ORDERS_URL } from "../constants";

const ordersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/createOrder`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    updateOrderStatus: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/updateOrderStatus`,
        method: "PUT",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getOrders: builder.query({
      query: (data) => ({
        url: `${ORDERS_URL}/getOrders?${data?.query ? data?.query : ""}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    createOuletOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/createOutletOrder`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    editOutletOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/editOutletOrder`,
        method: "PUT",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    updateInvoiceDate: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/updateInvoiceDate`,
        method: "PUT",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useGetOrdersQuery,
  useLazyGetOrdersQuery,
  useUpdateOrderStatusMutation,
  useCreateOuletOrderMutation,
  useEditOutletOrderMutation,
  useUpdateInvoiceDateMutation,
} = ordersApiSlice;
